import React, { useState } from "react";
import Disclosures from "../../../legal/Disclosures";
import "./css/DisclosuresModal.css";

/**
 * Reusable Disclosures Modal Component
 * Displays disclosures in a popup modal similar to Footer's legal modals
 */
function DisclosuresModal({ disclaimerText }) {
  const [showModal, setShowModal] = useState(false);

  const defaultDisclaimerText =
    "The analysis provided is for educational purposes only. For complete terms and limitations, please review our";

  return (
    <>
      {/* Footer with Disclosures Link */}
      <div className="analysis-footer">
        <div className="disclaimer-footer">
          <p>
            {disclaimerText || defaultDisclaimerText}{" "}
            <button
              type="button"
              className="disclosures-link-button"
              onClick={() => setShowModal(true)}
            >
              Disclosures
            </button>
            .
          </p>
        </div>
      </div>

      {/* Disclosures Modal */}
      {showModal && (
        <div
          className="disclosures-modal-overlay"
          onClick={() => setShowModal(false)}
        >
          <div
            className="disclosures-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="disclosures-modal-close-button"
              onClick={() => setShowModal(false)}
            >
              Close
            </button>
            <div className="disclosures-modal-body">
              <Disclosures />
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default DisclosuresModal;
